/**
 * Tier helpers — the single source of truth for "which paid features
 * should this user see?".
 *
 * Adopted Feb 2026 alongside the Advanced Trader tier. Retail free
 * (`individual`) sees the free-tier UI; Advanced (KES 1,000/mo) plus
 * both institutional tiers see the full copilot + higher-limits UI.
 *
 * Prefer `hasInstitutionalFeatures(user)` in new components. Existing
 * `isInstitutional = user?.tier === "moe_institution" || ...` patterns
 * still work but should be migrated on next touch.
 */

export const INSTITUTIONAL_LITE_TIERS = new Set([
    "advanced",
    "moe_institution",
    "cma_institution",
]);

export const TRUE_INSTITUTIONAL_TIERS = new Set([
    "moe_institution",
    "cma_institution",
]);

export function hasInstitutionalFeatures(user) {
    // Admin role bypasses tier gating so Super Admins can visually inspect
    // paywalled surfaces (Batch C/D/E — Options charts, Intel Hub, Shorts).
    // Mirrors the backend gates in routes/market_intel_hub.py + routes/shorts.py.
    if (user?.role === "admin") return true;
    return INSTITUTIONAL_LITE_TIERS.has(user?.tier || "");
}

export function isTrueInstitutional(user) {
    return TRUE_INSTITUTIONAL_TIERS.has(user?.tier || "");
}

export const TIER_DISPLAY = {
    individual:       "Individual",
    advanced:         "Advanced Trader",
    moe_institution:  "MoE Institution",
    cma_institution:  "CMA Institution",
    // legacy aliases
    free:             "Individual",
    expert:           "Individual",
};

export function tierDisplayLabel(user) {
    if (user?.role === "admin") return "Super Admin";
    return TIER_DISPLAY[user?.tier] || "Individual";
}
